/*
import { ContactService } from '../service/contact';
const cs = new ContactService();
const _init=async()=>{
    console.log(await ob.getContact({user_id:0}));
};
*/

import { API_ROUTE_CONTROLLER, API_VERBS } from "./route";
import { BaseService } from "./base";
// import Cookies from 'universal-cookie';
import { API_HOST } from "../config";
import { util, Cookie } from "../app/base/utils";

// const cookies = new Cookies();

export class LoginService extends BaseService {
  email = "";
  password = "";
  errmsg = "";
  checkRes = (res) => {
    if (res && res.statusCode && res.statusCode == 200 && typeof res.token != "undefined" && res.token) {
      return res;
    }
    return null;
  };

  login = async (email = "", password = "", remember_me = false) => {
    this.email = email;
    this.password = password;

    let login =  this.weblogin();
    if (login && login.length && login[0].errcode != 0) {
      return login;
    }
    // cookies.set('ssoToken', "testing", { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });

    let data = {
      'username': email,
      'password': password,
      'source': "Web",
      'deviceId': "myaccount-user-onboarding",
      'ipAddress': '182.66.104.115',
      // 'isForceLogin': false
      'isForceLogin': true
    };
    let res = await this.sso(API_ROUTE_CONTROLLER.create_jwt, data);
    res = this.checkRes(res);

    // if (!res) {
    //   data.isForceLogin = true;
    //   res = await this.sso(API_ROUTE_CONTROLLER.create_jwt, data);
    // }

    if (res) {
      Cookie.set("ssoToken", res.token, 1);
      // cookies.set('ssoToken', res.token, { path: '/', maxAge: (24 * 60 * 60 * 365), domain: API_HOST.sso_host });
      // cookies.set('ssoRefreshToken', res.refresh_token, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
      // cookies.set('appId', API_HOST.appId, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
      // cookies.set('appSecret', API_HOST.appSecret, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
    }

    if (remember_me) {
      Cookie.set("remember_me", true, 1);
      // cookies.set('remember_me', true, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
    } else {
      Cookie.set("remember_me", false, 1);
      // cookies.set('remember_me', false, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
    }
    return login;
  };

  logout = () => {
    Cookie.clear();
    // cookies.remove('ssoToken', { path: '/' });
    // cookies.remove('ssoRefreshToken', { path: '/' });
    // cookies.remove('appSecret', { path: '/' });
    // cookies.remove('appId', { path: '/' });
    window.location.href = "/";
  };

  weblogin = async () => {
    let data = {
      "mobileno": this.email,
      "password": this.password,
      "extension": 0,
      "device_type": 0,
      "browser": "",
      "login_type": 1
    };
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccweblogin, data));
  };

  planInfo = async (company_id) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.getBillServicePlan, { company_id: company_id }));
  };
  featureInfo = async (company_id, plan_id, feature_type = 1) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urgetaddonfeaturelist, { company_id: company_id, plan_id: plan_id, feature_type: feature_type }));
  };
  invoiceSummary = async (company_id) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urbillgetcustomerinvoicesummary, { company_id: company_id, Search_type: 'ALL', status_type: 0, invoice_id: 0 }));
  };

  forgotPassword = async (email) => {

      let hub = await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urapploginforgotpwd, { "email": email, "type": 1, "called_by": "WEB","domainUrl": "https://myaccount.worktual.co.uk" }));
      let emailOutput = await this.getResponse(await this.post(API_ROUTE_CONTROLLER.getUserDetailsByEmail, { "p_email": email}));
      console.log("emailOutputemailOutput",emailOutput?.users[0]?.Firstname)
      if (hub && hub.length && hub[0].errcode != -1) {
        const body = {
          "requested_password_reset": "Yes",
          "password_reset_link": hub[0]?.ResetURL,
          "firstname":emailOutput.users[0]?.Firstname,
          "email":email,
          "region":"UK"
        };
        return  await this.getResponse(await this.post(API_ROUTE_CONTROLLER.forgot_password_link_send,  body));
      }
    
    return null;
  };

  resetPassword = async (password, keys, medium, frame) => {
    keys = util.base64_decode(keys.trim());
    medium = util.base64_decode(medium.trim());
    frame = util.base64_decode(frame.trim());
    let res = await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urapploginforgotpwd, { 'email': keys.trim(), 'called_by': medium.trim(), 'log_id': frame.trim(), type: 3 }));
    if (res && res.length && res[0].errcode == -1) {
      this.errmsg = res[0].errmsg;
      return null;
    }
    res = await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urapploginforgotpwd, { 'email': keys.trim(), 'new_pwd': password.trim(), 'called_by': medium.trim(), 'log_id': frame.trim(), type: 2 }));
    return await this.login(keys.trim(), password.trim());
  };

  backendForgotPassword = async (email) => {
    // let url ="http://localhost:5006/qamyaccount-mysql/v1/login/forgot_password_backend";
    let url =API_ROUTE_CONTROLLER.forgot_password_backend;
   let body ={ 
      "domainUrl": API_HOST.basePath,
      "email": email,
      "region": "UK"
   }
      return  await this.getResponse(await this.post(url, body));
    
  
  };
}
